import { ApiProperty } from "@nestjs/swagger";

export class RmBomLogUpdateRequset{
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    assignedQty: number;
    constructor(saleOrderId:number,saleOrderItemId:number,assignedQty: number){
        this.saleOrderItemId = saleOrderItemId
        this.assignedQty = assignedQty
        this.saleOrderId = saleOrderId
    }
}